<template>
  <el-dialog
    :title="dialogTitle"
    :visible="visible"
    width="560px"
    append-to-body
    :lock-scroll="false"
    @update:visible="updateVisible"
    @opened="clearValidate">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="类型分类" prop="channel_type_id">
        <el-select v-model="form.channel_type_id" filterable placeholder="请选择" class="ele-block">
          <el-option
            v-for="item in typeList"
            :key="item.id"
            :label="item.channel_name"
            :value="Number(item.id)" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="isExternal" label="上游名称">
        <el-select v-model="form.uplist_id" filterable clearable placeholder="请选择" class="ele-block">
          <el-option
            v-for="item in upList"
            :key="item.id"
            :label="upLabel(item)"
            :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="isExternal" label="接入编码">
        <el-input v-model="form.up_code" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="通道名称">
        <el-input v-model="form.up_channel_name" clearable placeholder="请输入" />
      </el-form-item>
      <el-form-item label="基础费率">
        <el-input v-model="form.jc_rate" clearable placeholder="请输入">
          <template slot="suffix">%</template>
        </el-input>
      </el-form-item>
      <el-form-item label="支持金额" prop="money_gz">
        <el-input v-model="form.money_gz" clearable placeholder="请输入" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
const emptyForm = (typeId = 0) => ({
  id: undefined,
  status: 1,
  channel_type_id: typeId || undefined,
  uplist_id: '',
  up_code: '',
  up_channel_name: '',
  jc_rate: '',
  money_gz: ''
});

export default {
  name: 'ColumnEdit',
  props: {
    visible: Boolean,
    data: Object,
    addMode: { type: String, default: 'system' },
    channelTypeId: { type: Number, default: 0 },
    upList: { type: Array, default: () => [] }
  },
  data() {
    return {
      form: emptyForm(this.channelTypeId),
      typeList: [],
      rules: {
        channel_type_id: [{ required: true, message: '请选择', trigger: 'change' }],
        money_gz: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      loading: false,
      isUpdate: false
    };
  },
  computed: {
    isExternal() {
      return this.addMode === 'external';
    },
    dialogTitle() {
      const name = this.isExternal ? '外部通道' : '系统通道';
      return (this.isUpdate ? '编辑' : '添加') + name;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadTypes();
        this.initForm();
      } else {
        this.form = emptyForm(this.channelTypeId);
      }
    },
    data() {
      if (this.visible) this.initForm();
    }
  },
  methods: {
    clearValidate() {
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    upLabel(item) {
      const name = item && item.upName;
      const uid = item && item.upUid;
      return uid ? `${name}（${uid}）` : name;
    },
    loadTypes() {
      this.$http.get('/Channeltype/getchannelTypeList', { params: { sort_channel: 'out' } }).then((res) => {
        if (res.data.code === 0) {
          this.typeList = res.data.data || [];
        }
      }).catch(() => {});
    },
    initForm() {
      if (this.data && this.data.id) {
        this.isUpdate = true;
        this.form = {
          id: this.data.id,
          status: this.data.status || 1,
          channel_type_id: Number(this.data.channel_type_id || this.channelTypeId) || undefined,
          uplist_id: this.data.uplist_id,
          up_code: this.data.up_code,
          up_channel_name: this.data.up_channel_name,
          jc_rate: this.data.jc_rate == null ? '' : String(this.data.jc_rate),
          money_gz: this.data.money_gz == null ? '' : String(this.data.money_gz)
        };
      } else {
        this.isUpdate = false;
        this.form = emptyForm(this.channelTypeId);
      }
      this.clearValidate();
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const typeId = Number(this.form.channel_type_id || 0);
        if (!typeId) {
          this.$message.error('请选择类型分类');
          return;
        }
        if (!this.form.up_channel_name && this.isExternal) {
          const up = this.upList.find((item) => item.id === this.form.uplist_id);
          if (up) this.form.up_channel_name = this.upLabel(up);
        }
        this.loading = true;
        const payload = {
          channel_type_id: typeId,
          up_channel_name: this.form.up_channel_name,
          jc_rate: String(this.form.jc_rate || '').replace(/%/g, '').trim(),
          money_gz: this.form.money_gz,
          status: this.form.status || 1,
          uplist_id: this.isExternal ? (this.form.uplist_id || 0) : 0,
          up_code: this.isExternal ? this.form.up_code : '',
          resource_class_id: ''
        };
        if (this.form.id) payload.id = this.form.id;
        this.$http.post('/ChannelColumnOut/edit', payload).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
